module.exports = __webpack_public_path__ + "static/img/11b.c8d8218.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/11b.jpg
// module id = tcMh
// module chunks = 1